// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Box,
//   Tabs,
//   TabList,
//   TabPanels,
//   Tab,
//   TabPanel,
//   Table,
//   Thead,
//   Tbody,
//   Tr,   
//   Th,
//   Td,
//   TableContainer,
//   Text,
//   Link,
// } from "@chakra-ui/react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { Download, Eye } from "lucide-react";
// import { toast } from "react-toastify";
// import { getNationalPortalByID } from "../../../../redux/api/dms/DmsApi";

// function NationalPortalDetailView() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [serialNoData, setSerialNoData] = useState([]);
//   const [documents, setDocuments] = useState([]);

//   // Get data from location state
//   const ROWID = location.state.id
//   console.log("AdityaTest",ROWID);
  
//     const [nationalPortalData, setnationalPortalData] = useState({});
//     const [isLoading, setIsLoading] = useState(false);

  
//     // Fetch task data only in update mode
//     useEffect(() => {
//         if (ROWID) {
//             // setIsLoading(true);
//             getNationalPortalByID(ROWID)
//                 .then((response) => {
//                     console.log("GetTaskById---->", response.data);
//                     if (response.data.success) {
//                         console.log("Task Data:", response.data.task);
//                         const taskData = response.data.task;
//                         setnationalPortalData(taskData);
//                     }
//                 })
//                 .catch((error) => {
//                     console.log({ error });
                   
//                 })
//                 .finally(() => {
//                     setIsLoading(false);
//                 });
//         }
//     }, [ROWID]);
    

//   // useEffect(() => {
//   //   if (!portalData) {
//   //     // toast.error("No portal data available");
//   //     navigate(-1);
//   //     return;
//   //   }

//   //   // Parse serial number data
//   //   if (portalData.serialNo) {
//   //     try {
//   //       const parsed = typeof portalData.serialNo === 'string' 
//   //         ? JSON.parse(portalData.serialNo) 
//   //         : portalData.serialNo;
//   //       setSerialNoData(Array.isArray(parsed) ? parsed : []);
//   //     } catch (e) {
//   //       console.error("Error parsing serialNo:", e);
//   //       setSerialNoData([]);
//   //     }
//   //   }
    
//   //   // Set documents
//   //   if (portalData.documents) {
//   //     setDocuments(Array.isArray(portalData.documents) 
//   //       ? portalData.documents 
//   //       : []);
//   //   } else if (portalData.nationalPortalDocument) {
//   //     setDocuments(Array.isArray(portalData.nationalPortalDocument) 
//   //       ? portalData.nationalPortalDocument 
//   //       : []);
//   //   }
//   // }, [portalData, navigate]);

//   // Function to check if file is PDF
//   const isPDFFile = (fileUrl) => {
//     if (!fileUrl) return false;
//     const url = fileUrl.toLowerCase();
//     return url.endsWith('.pdf') || url.includes('.pdf') || url.includes('application/pdf');
//   };

//   // Handle file download
//   const handleDownload = async (fileUrl, fileName) => {
//     if (!fileUrl) {
//       toast.error("No file available for download");
//       return;
//     }

//     try {
//       const response = await fetch(fileUrl);
//       if (!response.ok) {
//         throw new Error('Network response was not ok');
//       }
      
//       const blob = await response.blob();
//       const url = window.URL.createObjectURL(blob);
//       const link = document.createElement('a');
//       link.href = url;
//       link.download = fileName || 'download';
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       window.URL.revokeObjectURL(url);
//       toast.success("File downloaded successfully");
//     } catch (error) {
//       console.error("Download error:", error);
//       toast.error("Failed to download file");
//     }
//   };

//   // Handle file view
//   const handleView = (fileUrl, fileName) => {
//     if (!fileUrl) {
//       toast.error("No file available to view");
//       return;
//     }

//     if (isPDFFile(fileUrl)) {
//       window.open(fileUrl, '_blank');
//     } else {
//       // For images, open in new tab
//       window.open(fileUrl, '_blank');
//     }
//   };

//   if (!portalData) {
//     return (
//       <div style={{ padding: "1rem" }}>
//         <Button onClick={() => navigate(-1)} className="create-button py-1" mb={4}>
//           Back
//         </Button>
//         <div>No portal data available</div>
//       </div>
//     );
//   }

//   return (
//     <div className="overflow-y-scroll" style={{ height: "92vh", padding: "1rem" }}>
//       <Tabs variant="enclosed" size="md">
//         <TabList>
//           <Tab>Overview</Tab>
//         </TabList>

//         <TabPanels>
//           <TabPanel>
//             <Button
//               className="create-button py-1"
//               mb={4}
//               onClick={() => navigate(-1)}
//               style={{ marginBottom: "1rem" }}
//             >
//               Back
//             </Button>

//             {/* National Portal Information */}
//             <div className="card card-detail mb-4">
//               <div className="card-header">
//                 <h4>National Portal Information</h4>
//               </div>
//               <div className="card-body">
//                 <table className="table">
//                   <tbody>
//                     <tr>
//                       <th style={{ width: "30%" }}>National Portal Number</th>
//                       <td>{portalData.nationalPortalNumber || portalData.nationalPortalNo || "N/A"}</td>
//                     </tr>
//                     <tr>
//                       <th>Apply Date</th>
//                       <td>{portalData.applyDate ? new Date(portalData.applyDate).toLocaleDateString() : "N/A"}</td>
//                     </tr>
//                     <tr>
//                       <th>Deal ID</th>
//                       <td>{portalData.dealId || "N/A"}</td>
//                     </tr>
//                     <tr>
//                       <th>Type</th>
//                       <td>{portalData.type || "N/A"}</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Panel Serial Numbers */}
//             {serialNoData && serialNoData.length > 0 && serialNoData.some(item => item.panelSerialNo) && (
//               <div className="card card-detail mb-4">
//                 <div className="card-header">
//                   <h4>Panel Serial Numbers</h4>
//                 </div>
//                 <div className="card-body">
//                   <TableContainer>
//                     <Table variant="simple">
//                       <Thead>
//                         <Tr>
//                           <Th>Serial Number</Th>
//                         </Tr>
//                       </Thead>
//                       <Tbody>
//                         {serialNoData
//                           .filter(item => item.panelSerialNo)
//                           .map((item, index) => (
//                             <Tr key={index}>
//                               <Td>{item.panelSerialNo || "N/A"}</Td>
//                             </Tr>
//                           ))}
//                       </Tbody>
//                     </Table>
//                   </TableContainer>
//                 </div>
//               </div>
//             )}

//             {/* Inverter Serial Numbers */}
//             {serialNoData && serialNoData.length > 0 && serialNoData.some(item => item.inverterSrNo) && (
//               <div className="card card-detail mb-4">
//                 <div className="card-header">
//                   <h4>Inverter Serial Numbers</h4>
//                 </div>
//                 <div className="card-body">
//                   <TableContainer>
//                     <Table variant="simple">
//                       <Thead>
//                         <Tr>
//                           <Th>Serial Number</Th>
//                         </Tr>
//                       </Thead>
//                       <Tbody>
//                         {serialNoData
//                           .filter(item => item.inverterSrNo)
//                           .map((item, index) => (
//                             <Tr key={index}>
//                               <Td>{item.inverterSrNo || "N/A"}</Td>
//                             </Tr>
//                           ))}
//                       </Tbody>
//                     </Table>
//                   </TableContainer>
//                 </div>
//               </div>
//             )}

//             {/* Documents */}
//             <div className="card card-detail mb-4">
//               <div className="card-header">
//                 <h4>Documents Required for National Portal</h4>
//               </div>
//               <div className="card-body">
//                 {documents && documents.length > 0 ? (
//                   <TableContainer>
//                     <Table variant="simple">
//                       <Thead>
//                         <Tr>
//                           <Th>Document</Th>
//                           <Th>File Name</Th>
//                           <Th>Actions</Th>
//                         </Tr>
//                       </Thead>
//                       <Tbody>
//                         {documents.map((doc, index) => (
//                           <Tr key={doc.ROWID || index}>
//                             <Td>{doc.document || "N/A"}</Td>
//                             <Td>
//                               {doc.fileName ? (
//                                 <Link href={doc.fileUrl} isExternal color="blue.500">
//                                   {doc.fileName}
//                                 </Link>
//                               ) : (
//                                 "N/A"
//                               )}
//                             </Td>
//                             <Td>
//                               <Box display="flex" gap={2}>
//                                 {doc.fileUrl && (
//                                   <>
//                                     <Eye
//                                       size={18}
//                                       style={{ cursor: "pointer" }}
//                                       color="#007bff"
//                                       onClick={() => handleView(doc.fileUrl, doc.fileName)}
//                                       title="View File"
//                                     />
//                                     <Download
//                                       size={18}
//                                       style={{ cursor: "pointer" }}
//                                       color="#ff176b"
//                                       onClick={() => handleDownload(doc.fileUrl, doc.fileName)}
//                                       title="Download File"
//                                     />
//                                   </>
//                                 )}
//                               </Box>
//                             </Td>
//                           </Tr>
//                         ))}
//                       </Tbody>
//                     </Table>
//                   </TableContainer>
//                 ) : (
//                   <Text>No documents available</Text>
//                 )}
//               </div>
//             </div>
//           </TabPanel>
//         </TabPanels>
//       </Tabs>
//     </div>
//   );
// }

// export default NationalPortalDetailView;



import React, { useState, useEffect } from "react";
import {
  Button,
  Box,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Table,
  Thead,
  Tbody,
  Tr,   
  Th,
  Td,
  TableContainer,
  Text,
  Link,
} from "@chakra-ui/react";
import { useNavigate, useLocation } from "react-router-dom";
import { Download, Eye } from "lucide-react";
import { toast } from "react-toastify";
import { getNationalPortalByID } from "../../../../redux/api/dms/DmsApi";

function NationalPortalDetailView() {
  const navigate = useNavigate();
  const location = useLocation();
  const [serialNoData, setSerialNoData] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [nationalPortalData, setNationalPortalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Get data from location state
  const ROWID = location.state?.id;

  // Fetch task data only in update mode
  useEffect(() => {
    if (ROWID) {
      setIsLoading(true);
      getNationalPortalByID(ROWID)
        .then((response) => {
          console.log("GetTaskById---->", response.data);
          if (response.data.success) {
            console.log("Task Data:", response.data.response);
            const portalData = response.data.response;
            setNationalPortalData(portalData);

            // Parse serial number data
            if (portalData.serialNo) {
              try {
                const parsed = typeof portalData.serialNo === 'string' 
                  ? JSON.parse(portalData.serialNo) 
                  : portalData.serialNo;
                setSerialNoData(Array.isArray(parsed) ? parsed : []);
              } catch (e) {
                console.error("Error parsing serialNo:", e);
                setSerialNoData([]);
              }
            }
            
            // Set documents
            if (portalData.nationalPortalDocument) {
              setDocuments(Array.isArray(portalData.nationalPortalDocument) 
                ? portalData.nationalPortalDocument 
                : []);
            }
          } else {
            toast.error("Failed to fetch portal data");
            navigate(-1);
          }
        })
        .catch((error) => {
          console.log({ error });
          toast.error("Error fetching portal data");
          navigate(-1);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      toast.error("No portal ID provided");
      navigate(-1);
    }
  }, [ROWID, navigate]);

  // Function to check if file is PDF
  const isPDFFile = (fileUrl) => {
    if (!fileUrl) return false;
    const url = fileUrl.toLowerCase();
    return url.endsWith('.pdf') || url.includes('.pdf') || url.includes('application/pdf');
  };

  // Handle file download
  const handleDownload = async (fileUrl, fileName) => {
    if (!fileUrl) {
      toast.error("No file available for download");
      return;
    }

    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success("File downloaded successfully");
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Failed to download file");
    }
  };

  // Handle file view
  const handleView = (fileUrl, fileName) => {
    if (!fileUrl) {
      toast.error("No file available to view");
      return;
    }

    if (isPDFFile(fileUrl)) {
      window.open(fileUrl, '_blank');
    } else {
      // For images, open in new tab
      window.open(fileUrl, '_blank');
    }
  };

  if (isLoading) {
    return (
      <div style={{ padding: "1rem" }}>
        <Button onClick={() => navigate(-1)} className="create-button py-1" mb={4}>
          Back
        </Button>
        <div>Loading...</div>
      </div>
    );
  }

  if (!nationalPortalData) {
    return (
      <div style={{ padding: "1rem" }}>
        <Button onClick={() => navigate(-1)} className="create-button py-1" mb={4}>
          Back
        </Button>
        <div>No portal data available</div>
      </div>
    );
  }

  return (
    <div className="overflow-y-scroll" style={{ height: "92vh", padding: "1rem" }}>
      <Tabs variant="enclosed" size="md">
        <TabList>
          <Tab>Overview</Tab>
        </TabList>

        <TabPanels>
          <TabPanel>
            <Button
              className="create-button py-1"
              mb={4}
              onClick={() => navigate(-1)}
              style={{ marginBottom: "1rem" }}
            >
              Back
            </Button>

            {/* National Portal Information */}
            <div className="card card-detail mb-4">
              <div className="card-header">
                <h4>National Portal Information</h4>
              </div>
              <div className="card-body">
                <table className="table">
                  <tbody>
                    <tr>
                      <th style={{ width: "30%" }}>National Portal Number</th>
                      <td>{nationalPortalData.nationalPortalNumber || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Apply Date</th>
                      <td>{nationalPortalData.applyDate ||  "N/A"}</td>
                    </tr>
                    {/* <tr>
                      <th>Deal ID</th>
                      <td>{nationalPortalData.dealId || "N/A"}</td>
                    </tr> */}
                    {/* <tr>
                      <th>Type</th>
                      <td>{nationalPortalData.type || "N/A"}</td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Panel Serial Numbers */}
            {serialNoData && serialNoData.length > 0 && serialNoData.some(item => item.panelSerialNo) && (
              <div className="card card-detail mb-4">
                <div className="card-header">
                  <h4>Panel Serial Numbers</h4>
                </div>
                <div className="card-body">
                  <TableContainer>
                    <Table variant="simple">
                      <Thead>
                        <Tr>
                          <Th>Serial Number</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {serialNoData
                          .filter(item => item.panelSerialNo && item.panelSerialNo.trim() !== "")
                          .map((item, index) => (
                            <Tr key={index}>
                              <Td>{item.panelSerialNo || "N/A"}</Td>
                            </Tr>
                          ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            )}

            {/* Inverter Serial Numbers */}
            {serialNoData && serialNoData.length > 0 && serialNoData.some(item => item.inverterSrNo) && (
              <div className="card card-detail mb-4">
                <div className="card-header">
                  <h4>Inverter Serial Numbers</h4>
                </div>
                <div className="card-body">
                  <TableContainer>
                    <Table variant="simple">
                      <Thead>
                        <Tr>
                          <Th>Serial Number</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {serialNoData
                          .filter(item => item.inverterSrNo && item.inverterSrNo.trim() !== "")
                          .map((item, index) => (
                            <Tr key={index}>
                              <Td>{item.inverterSrNo || "N/A"}</Td>
                            </Tr>
                          ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            )}

            {/* Documents */}
            <div className="card card-detail mb-4">
              <div className="card-header">
                <h4>Documents Required for National Portal</h4>
              </div>
              <div className="card-body">
                {documents && documents.length > 0 ? (
                  <TableContainer>
                    <Table variant="simple">
                      <Thead>
                        <Tr>
                          <Th>Document</Th>
                          <Th>File Name</Th>
                          <Th>Actions</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {documents.map((doc, index) => (
                          <Tr key={doc.ROWID || index}>
                            <Td>{doc.document || "N/A"}</Td>
                            <Td>
                              {doc.fileName ? (
                                <Link href={doc.fileUrl} isExternal color="blue.500">
                                  {doc.fileName}
                                </Link>
                              ) : (
                                "N/A"
                              )}
                            </Td>
                            <Td>
                              <Box display="flex" gap={2}>
                                {doc.fileUrl && (
                                  <>
                                    <Eye
                                      size={18}
                                      style={{ cursor: "pointer" }}
                                      color="#007bff"
                                      onClick={() => handleView(doc.fileUrl, doc.fileName)}
                                      title="View File"
                                    />
                                    <Download
                                      size={18}
                                      style={{ cursor: "pointer" }}
                                      color="#ff176b"
                                      onClick={() => handleDownload(doc.fileUrl, doc.fileName)}
                                      title="Download File"
                                    />
                                  </>
                                )}
                              </Box>
                            </Td>
                          </Tr>
                        ))}
                      </Tbody>
                    </Table>
                  </TableContainer>
                ) : (
                  <Text>No documents available</Text>
                )}
              </div>
            </div>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
}

export default NationalPortalDetailView;